import React, { useState } from 'react'
import Header from './header/Header'
import Stepper from './stepper/Stepper'
import { initPersonalInfo, prelevement, PrelevementContext } from './PrelevementContext'
import { connect } from 'react-redux'
import { RootState } from '../../reducers'
import { ContractsModel, ContractsOmission } from '../../../types/contracts/contractsModel'
import Footer from '../../../components/modalStepper/footer/Footer'
import { ProfileShortModel, SignResponseModel } from '../profileModel'
import { PRL_AUTO } from '../../../enums/contractsEnum'
import links from '../../../enums/linksEnum'
import { useHistory } from 'react-router'

interface AcceptingProps {
	userDetails: ProfileShortModel,
	closeDialog: () => void
}

interface Store {
	contracts: Omit<ContractsModel, ContractsOmission>[]
}

type MakeRequestProps =
	AcceptingProps
	& Store

const MakeRequest: React.FC<MakeRequestProps> = (
	{
		userDetails,
		closeDialog,
		contracts
	}
) => {
	const contractsWithoutPrelevement = contracts.filter(contract => contract.typeDePaiement !== PRL_AUTO)
	const history = useHistory()
	const [step, setStep] = useState<number>(1)
	const [signResponse, setSignResponse] = useState<SignResponseModel | undefined>(undefined)
	const [signStatus, setSignStatus] = React.useState<string | undefined>(undefined)
	const startsWithPropertyConcerned: number = contractsWithoutPrelevement.length > 1 ? step - 1 : step
	const stepNumber: number = contractsWithoutPrelevement.length > 1 ? 4 : 3

	const previousStep = () => {
		setStep(step - 1)
	}
	const nextStep = (signResponse?: SignResponseModel) => {
		setStep(step + 1)
		if (signResponse) {
			setSignResponse(signResponse)
		}
	}

	const resetStep = () => {
		setStep(1)
		prelevement.personalInfo = initPersonalInfo
	}

	//Go to request tab
	const goToRequests = () => {
		history.push(links.requests)
	}

	const onCloseDialog = () => {
		setStep(1)
		prelevement.personalInfo = initPersonalInfo
		closeDialog()
		if (step === stepNumber && !(signResponse && !signStatus)) {
			goToRequests()
		}
	}

	const initPrelevement = contractsWithoutPrelevement.length === 1 ? {
		...prelevement,
		propertyConcerned: [contractsWithoutPrelevement[0] as ContractsModel]
	} : prelevement

	return (
		<>
			<Header
				closeDialog={onCloseDialog}
				startsWithPropertyConcerned={startsWithPropertyConcerned}
			/>

			<PrelevementContext.Provider
				value={{
					prelevement: initPrelevement,
					userDetails,
					step,
					previousStep,
					nextStep,
					closeDialog,
					resetStep,
					setPersonalInfo: (values) => {
						prelevement.personalInfo = values
					}
				}}
			>
				<Stepper
					signResponse={signResponse}
					contracts={contractsWithoutPrelevement}
					step={step}
					startsWithPropertyConcerned={startsWithPropertyConcerned}
					stepNumber={stepNumber}
					setSignStatus={setSignStatus}
					signStatus={signStatus}
				/>
			</PrelevementContext.Provider>

			{
				((stepNumber === 3 && startsWithPropertyConcerned > 1) || (stepNumber === 2 && startsWithPropertyConcerned >= 2)) && startsWithPropertyConcerned < 3 &&
				<Footer onFooterPreviousClicked={previousStep} />
			}
		</>
	)
}

const mapStateToProps = (state: RootState) => (
	{
		contracts: state.contracts
	}
)

export default connect(mapStateToProps)(MakeRequest)
